import axios from "axios";
import { usePageContext } from "../features/context/PageContext";
import { _TEST1234 } from "../features/config/ApiConfig";

const promise = (ref: any, pgeUid: any) => {
    return new Promise<void>(async (resolve, reject) => {
        try {
            const ogaflag = _TEST1234.SYSTEM_GROUP_ENV === "tanoga" ? "oga/" : "";
            const base = `${_TEST1234.PORTAL_API_ENV}/api/v1/${_TEST1234.PORTAL_TYPE}/comn/menu/${ogaflag}scrn`;
            const pQuery = `?scrnId=${pgeUid}`;
            const url = base + pQuery;
            const { data } = await axios.get(url, {
                headers: { "Accept-Language": _TEST1234.LANGUAGE },
            });
            ref.current.pages[pgeUid].data = data.scrnDtl;
            ref.current.pages[pgeUid].status = "fulfilled";
            resolve();
        } catch (error) {
            ref.current.pages[pgeUid].status = "rejected";
            resolve();
        }
    });
};

const checkUrl = (ref: any) => {
    try {
        if (!ref.current.isPopup && !ref.current.isMenu) {
            throw new Error();
        }
    } catch (error) {
        if (process.env.NODE_ENV === "production") {
            window.location.href = window.location.origin + process.env.REACT_APP_BASE + "/404";
        }
    }
};

const checkPermission = (ref: any, auth: any) => {
    // Skip permission check when the screen is embedded in the Electronic Approval detail iframe
    // !== 전자결재 상세로 임베드된 화면은 결재자가 해당 업무 권한이 없어도 열람 가능해야 하므로 권한 체크를 건너뜀 ==!
    if (ref.current.menuId === "elecAprv") return;
    try {
        if (Array.isArray(auth)) {
            const authorization = _TEST1234.AUTHORIZATION;
            const authList = JSON.parse(window.sessionStorage.getItem("user-info") || "")?.authList;
            if (
                !authorization || // No authorization
                !Array.isArray(authList) || // No user's auth list
                !authList.some((item) => auth.includes(item)) // No permission
            ) {
                throw new Error();
            }
        }
    } catch (error) {
        window.location.href = window.location.origin + process.env.REACT_APP_BASE + "/401";

        // if (process.env.NODE_ENV === "production") {
        //     // console.log("%c권한이 없습니다", "color: red");
        // } else {
        //     alert("권한이 없습니다");
        //     window.location.href = window.location.origin + process.env.REACT_APP_BASE + "/401";
        // }
    }
};

const fetchPageData = (ref: any, pgeUid: any) => {
    if (!ref.current.pages[pgeUid]) {
        ref.current.pages[pgeUid] = {};
        ref.current.pages[pgeUid].pgeUid = pgeUid;
        ref.current.pages[pgeUid].status = "pending";
        ref.current.pages[pgeUid].promise = promise(ref, pgeUid);
        ref.current.pages[pgeUid].data = {};
    }
};

type UsePageParams = {
    pgeUid?: string;
    auth?: string[];
};

type UsePageReturn = {
    data: any;
    pgeUid: string;
    menuId: string;
    from: string | null;
    back: () => void;
};

export const usePage = (params: UsePageParams = {}): UsePageReturn => {
    const { ref } = usePageContext();

    const { pgeUid = ref.current.pgeUid, auth } = params;

    // Check url
    checkUrl(ref);

    // Check permission
    checkPermission(ref, auth);

    // Fetch page data
    fetchPageData(ref, pgeUid);

    const obj: any = {
        data: ref.current.pages[pgeUid].data,
        pgeUid,
        menuId: ref.current.menuId,
        from: null,
        back: () => {},
    };

    // Done
    switch (ref.current.pages[pgeUid].status) {
        case "fulfilled": {
            if (ref.current.isFrom) {
                obj.from = ref.current.menuId;
                obj.back = () => {
                    const systemOrigin =
                        process.env.REACT_APP_API_FRONT_OSCI ||
                        process.env.REACT_APP_API_FRONT_PTL_COMN ||
                        window.location.origin;
                    const path = ref.current.from?.path || "";
                    window.location.href = systemOrigin + path;
                    // let systemOrigin = window.location.origin;
                    // if (process.env.NODE_ENV === "development") {
                    //     let systemGroup = _TEST1234.SYSTEM_GROUP_ENV;
                    //     systemOrigin = "http://localhost:3400";
                    // }
                    // const path = ref.current.from?.path || "";
                    // window.location.href = systemOrigin + path;
                };
            }
            return obj;
        }
        case "rejected":
            return obj;
        default:
            throw ref.current.pages[pgeUid].promise;
    }
};
